import cx from 'classnames';
import './skeleton-loader.sass';

interface SkeletonLoaderProps {
  variant?: 'header' | 'navigation' | 'text' | 'rectangular' | 'circular';
  width?: string | number;
  height?: string | number;
  className?: string;
}

export function SkeletonLoader({ variant = 'text', width, height, className }: SkeletonLoaderProps) {
  const style = {
    width: width ? (typeof width === 'number' ? `${width}px` : width) : undefined,
    height: height ? (typeof height === 'number' ? `${height}px` : height) : undefined,
  };

  return <div className={cx('skeleton-loader', `skeleton-loader--${variant}`, className)} style={style} />;
}

interface HeaderSkeletonProps {
  v2Mode?: boolean;
}

export function HeaderSkeleton({ v2Mode = false }: HeaderSkeletonProps) {
  return (
    <div
      className={cx(v2Mode ? 'min-h-[48px] md:min-h-[64px]' : 'min-h-[80px]', 'items-center flex bg-primary-root px-9')}
    >
      <div className="w-full hidden md:block">
        <div className="flex gap-5 justify-between mx-auto">
          {/* Logo skeleton */}
          <div className="flex-none md:flex md:gap-5 md:flex-2">
            <SkeletonLoader variant="rectangular" width={133} height={45} />
          </div>

          <div className="flex-7 hidden md:block" />

          {/* User controls skeleton */}
          <div className="flex gap-5 md:gap-8 flex-1 items-center justify-end">
            <SkeletonLoader variant="text" width={60} />
            <SkeletonLoader variant="rectangular" width={120} height={30} />
            <SkeletonLoader variant="circular" width={40} height={40} />
          </div>
        </div>
      </div>

      {/* Mobile header skeleton */}
      <div className="flex items-center px-3 w-full md:hidden">
        <div className="flex-none pl-4">
          <SkeletonLoader variant="rectangular" width={100} height={40} />
        </div>
        <div className="flex-1" />
        <div className="flex items-center gap-4">
          <SkeletonLoader variant="circular" width={40} height={40} />
        </div>
      </div>
    </div>
  );
}

export function NavigationSkeleton() {
  return (
    <div className="min-h-[40px] bg-[#e5e5e5] px-9 py-2">
      <div className="flex gap-5 items-center justify-between">
        <div className="flex gap-2 items-center">
          <SkeletonLoader variant="text" width={100} />
          <span className="text-gray-500"></span>
          <SkeletonLoader variant="text" width={150} />
        </div>
        <div className="flex gap-2">
          <SkeletonLoader variant="rectangular" width={80} height={30} />
          <SkeletonLoader variant="rectangular" width={40} height={30} />
        </div>
      </div>
    </div>
  );
}
